import "./legacy.css";

import React from "react";
import { Helmet } from "react-helmet";

import MainContent from "../general/MainContent";
import BreadCrumbs from "../sections/Breadcrumbs";
import HeadBanner from "../sections/HeadBanner";
import InfoSection from "../sections/InfoSection";
import Socials from "../sections/Socials";

const Legacy = () => {
  return (
    <MainContent>
      <Helmet>
        <title>Charles Greig | Our Legacy</title>
      </Helmet>
      
      <HeadBanner
        imageLg={"/images/about/Legacy-Banner-new.jpg"}
        headPreGreen={"Our"}
        headWhite={"Legacy"}
        buttonLabel={"Explore"}
      />

      <BreadCrumbs
        crumbs={[
          { text: "Home", link: "/" },
          { text: "Our Legacy", link: "" },
        ]}
      />

      <section className={"about-section standard-width"}>
        <p className={"about-outlined"}>
          Heirloom pieces are handed down from generation to generation – and so too are the skills of the artisans who create them.
          <br />
          The Charles Greig Jewellers legacy is the story of five generations of a family, a nascent city and an ocean liner.
        </p>
      </section>

      <InfoSection
        info={{
          image: "/images/about/legacy-1-new.jpg",
          headPreGreen: "Charles Greig",
          headWhite: "The Start of a Legacy",
          subHead: `
            When, in 1894, the mail ship, RMS Scot, sounded its foghorn across Table Bay in the early hours of the morning, 
            its bright yellow chimneys barely visible in the mist, it unknowingly heralded the arrival of the Greig name in 
            South Africa and the proud legacy that would come to be known as Charles Greig Jewellers. For among the passengers 
            to disembark in Cape Town that morning was a young Scot by the name of Charles Greig, who was eager to make his mark 
            in a country, where the lure of gold and diamonds held enormous opportunity.
          `,
        }}
        containImg={true}
      />

      <InfoSection
        info={{
          image: "/images/about/legacy-2-new.jpg",
          headPreGreen: "Johannesburg",
          headWhite: "City of Gold",
          subHead: `
            He travelled inland to the reef town of Johannesburg, where, in 1899,  he founded Charles Greig Jewellers on a bustling 
            and dusty Market Street. Charles Greig would however barricade his doors shortly thereafter, when he would take up arms 
            in the second Anglo Boer war. Following gallant action at Spionkop he returned to find his padlocked shop wholly untouched. 
            The jewellery shop that now found itself in the fashionable surrounds of the original Carlton Hotel would experience the 
            “Roaring Twenties”, the “Crash of Twenty-Nine” and importantly, the discovery of one diamond so superior, it was referred 
            to by King George V as the “Great Star of Africa”.
          `,
        }}
        isVariant={true}
      />
      
      <InfoSection
        info={{
          image: "/images/about/legacy-3-new.jpg",
          headPreGreen: "Charles Hector",
          headWhite: "Greig",
          subHead: `
            It was this diamond, the Cullinan, that would totally ignite world interest in the riches of South Africa and spark off 
            such dramatic statements as “No such Brobdingnagian find as this 3032 carat stone has ever been recorded in the history of man”, 
            as reported in the Cape Argus of 1905. Charles Greig died in 1944, just before the end of World War II, leaving behind a rich 
            inheritance of old fashioned skill and craftsmanship that his son Charles Hector Greig would continue to build upon. 
          `,
        }}
        containImg={true}
      />
      
      <InfoSection
        info={{
          image: "/images/about/legacy-4-new.jpg",
          headPreGreen: "David",
          headWhite: "Greig",
          subHead: `
             In 1952, third generation David Greig returned to Johannesburg having completed his watch making studies in Switzerland. 
             David relocated the store to Commissioner Street in the late 50’s, opposite the CNA building and closer to The Rand Club, 
             the Banks, the Mining Houses of Marshalltown and the Johannesburg Stock Exchange.
          `,
        }}
        containImg={true}
        isVariant={true}
      />

      <InfoSection
        info={{
          image: "/images/about/legacy-5-new.jpg",
          headPreGreen: "Christopher, Donald & Richard",
          headWhite: "Greig",
          subHead: `
            Italia Greig, with her three Fourth generation sons Christopher, Donald and Richard, are the current face of Charles Greig in the 21st century. 
            The three brothers joined the company in the early 80’s and today, 125 years later, continue to nurture and further the legacy of Charles Greig Jewellers.
          `,
        }}
      />
      
      {/* <InfoSection
        info={{
          image: "/images/about/legacy-6.jpg",
          headPreGreen: "Tammy",
          headWhite: "Greig",
          subHeadHtml: `
            <p>
              Donald Greig’s daughter, Tammy, is the first member of the fifth generation of the family to enter the business – and, in a refreshing
              development – the first woman to join it since Elsa Grey flew the length of Africa over 70 years ago. 
            </p>
            <p>
              Tammy was born with gold dust in her veins; in addition, she has been imbued with the knowledge and emotion needed to be a professional
              jeweller from an early age. No-one could have predicted, back in 1889, that the name of Charles Greig would one day be known
              throughout South Africa; foreseeing a glowing future for the business is a much easier task now that this latest generation is
              bringing its own energy and ideas to this venerable institution.
            </p>
            <p>
              Currently based in London, Tammy represents the Charles Greig brand in the United Kingdom and Europe.
            <p>
          `,
        }}
        isVariant={true}
      /> */}
      <Socials />
    </MainContent>
  );
};

export default Legacy;